// @generated by Peggy 5.0.6.
//
// https://peggyjs.org/

"use strict";

class peg$SyntaxError extends SyntaxError {
  constructor(message, expected, found, location) {
    super(message);
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";
  }

  format(sources) {
    let str = "Error: " + this.message;
    if (this.location) {
      let src = null;
      const st = sources.find(s => s.source === this.location.source);
      if (st) {
        src = st.text.split(/\r\n|\n|\r/g);
      }
      const s = this.location.start;
      const offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
        ? this.location.source.offset(s)
        : s;
      const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
      if (src) {
        const e = this.location.end;
        const filler = "".padEnd(offset_s.line.toString().length, " ");
        const line = src[s.line - 1];
        const last = s.line === e.line ? e.column : line.length + 1;
        const hatLen = (last - s.column) || 1;
        str += "\n --> " + loc + "\n"
            + filler + " |\n"
            + offset_s.line + " | " + line + "\n"
            + filler + " | " + "".padEnd(s.column - 1, " ")
            + "".padEnd(hatLen, "^");
      } else {
        str += "\n at " + loc;
      }
    }
    return str;
  }

  static buildMessage(expected, found) {
    function hex(ch) {
      return ch.codePointAt(0).toString(16).toUpperCase();
    }

    const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode")
      ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu")
      : null;
    function unicodeEscape(s) {
      if (nonPrintable) {
        return s.replace(nonPrintable,  ch => "\\u{" + hex(ch) + "}");
      }
      return s;
    }

    function literalEscape(s) {
      return unicodeEscape(s
        .replace(/\\/g, "\\\\")
        .replace(/"/g,  "\\\"")
        .replace(/\0/g, "\\0")
        .replace(/\t/g, "\\t")
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/[\x00-\x0F]/g,          ch => "\\x0" + hex(ch))
        .replace(/[\x10-\x1F\x7F-\x9F]/g, ch => "\\x"  + hex(ch)));
    }

    function classEscape(s) {
      return unicodeEscape(s
        .replace(/\\/g, "\\\\")
        .replace(/\]/g, "\\]")
        .replace(/\^/g, "\\^")
        .replace(/-/g,  "\\-")
        .replace(/\0/g, "\\0")
        .replace(/\t/g, "\\t")
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/[\x00-\x0F]/g,          ch => "\\x0" + hex(ch))
        .replace(/[\x10-\x1F\x7F-\x9F]/g, ch => "\\x"  + hex(ch)));
    }

    const DESCRIBE_EXPECTATION_FNS = {
      literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },

      class(expectation) {
        const escapedParts = expectation.parts.map(
          part => (Array.isArray(part)
            ? classEscape(part[0]) + "-" + classEscape(part[1])
            : classEscape(part))
        );

        return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
      },

      any() {
        return "any character";
      },

      end() {
        return "end of input";
      },

      other(expectation) {
        return expectation.description;
      },
    };

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      const descriptions = expected.map(describeExpectation);
      descriptions.sort();

      if (descriptions.length > 0) {
        let j = 1;
        for (let i = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ")
            + ", or "
            + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  }
}

function peg$parse(input, options) {
  options = options !== undefined ? options : {};

  const peg$FAILED = {};
  const peg$source = options.grammarSource;

  const peg$startRuleFunctions = {
    Start: peg$parseStart,
  };
  let peg$startRuleFunction = peg$parseStart;

  const peg$c0 = "&{";
  const peg$c1 = "}";
  const peg$c2 = ")";
  const peg$c3 = "theta";
  const peg$c4 = "Str";
  const peg$c5 = "L";
  const peg$c6 = "list";
  const peg$c7 = "(";
  const peg$c8 = "E";
  const peg$c9 = ".";
  const peg$c10 = "\"";
  const peg$c11 = "Ans";
  const peg$c12 = "getKey";
  const peg$c13 = "{";
  const peg$c14 = "-";
  const peg$c15 = "=";
  const peg$c16 = "!=";
  const peg$c17 = ">=";
  const peg$c18 = ">";
  const peg$c19 = "<=";
  const peg$c20 = "<";
  const peg$c21 = " and ";
  const peg$c22 = " or ";
  const peg$c23 = " xor ";
  const peg$c24 = ",";
  const peg$c25 = "->";
  const peg$c26 = "If ";
  const peg$c27 = "Then";
  const peg$c28 = "Else";
  const peg$c29 = "For(";
  const peg$c30 = "While ";
  const peg$c31 = "Repeat ";
  const peg$c32 = "End";
  const peg$c33 = "Pause";
  const peg$c34 = "Lbl ";
  const peg$c35 = "Goto ";
  const peg$c36 = "IS>(";
  const peg$c37 = "DS<(";
  const peg$c38 = "Menu(";
  const peg$c39 = "prgm";
  const peg$c40 = "Return";
  const peg$c41 = "Stop";
  const peg$c42 = "DelVar ";
  const peg$c43 = "GraphStyle(";
  const peg$c44 = "OpenLib(";
  const peg$c45 = "ExecLib(";
  const peg$c46 = "Input ";
  const peg$c47 = "Prompt ";
  const peg$c48 = "Disp ";
  const peg$c49 = "DispGraph";
  const peg$c50 = "DispTable";
  const peg$c51 = "Output(";
  const peg$c52 = "ClrHome";
  const peg$c53 = "ClrTable";
  const peg$c54 = "GetCalc(";
  const peg$c55 = "Get(";
  const peg$c56 = "Send(";

  const peg$r0 = /^[A-Z]/;
  const peg$r1 = /^[A-Z0-9]/;
  const peg$r2 = /^[0-9]/;
  const peg$r3 = /^[1-6]/;
  const peg$r4 = /^[+\-]/;
  const peg$r5 = /^[^"]/;
  const peg$r6 = /^[*\/]/;

  const peg$e0 = peg$literalExpectation("&{", false);
  const peg$e1 = peg$literalExpectation("}", false);
  const peg$e2 = peg$anyExpectation();
  const peg$e3 = peg$classExpectation([["A", "Z"]], false, false, false);
  const peg$e4 = peg$classExpectation([["A", "Z"], ["0", "9"]], false, false, false);
  const peg$e5 = peg$classExpectation([["0", "9"]], false, false, false);
  const peg$e6 = peg$literalExpectation(")", false);
  const peg$e7 = peg$literalExpectation("theta", false);
  const peg$e8 = peg$literalExpectation("Str", false);
  const peg$e9 = peg$literalExpectation("L", false);
  const peg$e10 = peg$classExpectation([["1", "6"]], false, false, false);
  const peg$e11 = peg$literalExpectation("list", false);
  const peg$e12 = peg$literalExpectation("(", false);
  const peg$e13 = peg$classExpectation(["+", "-"], false, false, false);
  const peg$e14 = peg$literalExpectation("E", false);
  const peg$e15 = peg$literalExpectation(".", false);
  const peg$e16 = peg$classExpectation(["\""], true, false, false);
  const peg$e17 = peg$literalExpectation("\"", false);
  const peg$e18 = peg$literalExpectation("Ans", false);
  const peg$e19 = peg$literalExpectation("getKey", false);
  const peg$e20 = peg$literalExpectation("{", false);
  const peg$e21 = peg$literalExpectation("-", false);
  const peg$e22 = peg$classExpectation(["*", "/"], false, false, false);
  const peg$e23 = peg$literalExpectation("=", false);
  const peg$e24 = peg$literalExpectation("!=", false);
  const peg$e25 = peg$literalExpectation(">=", false);
  const peg$e26 = peg$literalExpectation(">", false);
  const peg$e27 = peg$literalExpectation("<=", false);
  const peg$e28 = peg$literalExpectation("<", false);
  const peg$e29 = peg$literalExpectation(" and ", false);
  const peg$e30 = peg$literalExpectation(" or ", false);
  const peg$e31 = peg$literalExpectation(" xor ", false);
  const peg$e32 = peg$literalExpectation(",", false);
  const peg$e33 = peg$literalExpectation("->", false);
  const peg$e34 = peg$literalExpectation("If ", false);
  const peg$e35 = peg$literalExpectation("Then", false);
  const peg$e36 = peg$literalExpectation("Else", false);
  const peg$e37 = peg$literalExpectation("For(", false);
  const peg$e38 = peg$literalExpectation("While ", false);
  const peg$e39 = peg$literalExpectation("Repeat ", false);
  const peg$e40 = peg$literalExpectation("End", false);
  const peg$e41 = peg$literalExpectation("Pause", false);
  const peg$e42 = peg$literalExpectation("Lbl ", false);
  const peg$e43 = peg$literalExpectation("Goto ", false);
  const peg$e44 = peg$literalExpectation("IS>(", false);
  const peg$e45 = peg$literalExpectation("DS<(", false);
  const peg$e46 = peg$literalExpectation("Menu(", false);
  const peg$e47 = peg$literalExpectation("prgm", false);
  const peg$e48 = peg$literalExpectation("Return", false);
  const peg$e49 = peg$literalExpectation("Stop", false);
  const peg$e50 = peg$literalExpectation("DelVar ", false);
  const peg$e51 = peg$literalExpectation("GraphStyle(", false);
  const peg$e52 = peg$literalExpectation("OpenLib(", false);
  const peg$e53 = peg$literalExpectation("ExecLib(", false);
  const peg$e54 = peg$literalExpectation("Input ", false);
  const peg$e55 = peg$literalExpectation("Prompt ", false);
  const peg$e56 = peg$literalExpectation("Disp ", false);
  const peg$e57 = peg$literalExpectation("DispGraph", false);
  const peg$e58 = peg$literalExpectation("DispTable", false);
  const peg$e59 = peg$literalExpectation("Output(", false);
  const peg$e60 = peg$literalExpectation("ClrHome", false);
  const peg$e61 = peg$literalExpectation("ClrTable", false);
  const peg$e62 = peg$literalExpectation("GetCalc(", false);
  const peg$e63 = peg$literalExpectation("Get(", false);
  const peg$e64 = peg$literalExpectation("Send(", false);

  function peg$f0() {    return true  }
  function peg$f1() {    return text();  }
  function peg$f2() {    return text();  }
  function peg$f3() {    return 'THETA'  }
  function peg$f4() {    return text();  }
  function peg$f5(number) {    return types.ListVariablePrefix + number;  }
  function peg$f6(prefix) {    return types.ListVariablePrefix + text().substring(prefix.length + 3);  }
  function peg$f7(name) {    return { type: types.NumberVariable, name }  }
  function peg$f8(name) {    return { type: types.StringVariable, name }  }
  function peg$f9(name) {    return { type: types.ListVariable, name, custom: false }  }
  function peg$f10(name) {    return { type: types.ListVariable, name, custom: true }  }
  function peg$f11(list, index) {    return { type: types.ListIndex, list, index }  }
  function peg$f12(integer, fraction, exponent) {    
       return { type: types.TiNumber, integer, fraction, exponent }
  }
  function peg$f13(fraction, exponent) {    
       return { type: types.TiNumber, fraction, exponent }
  }
  function peg$f14(integer, exponent) {    
       return { type: types.TiNumber, integer, exponent }
  }
  function peg$f15(chars) {    return { type: types.TiString, chars }  }
  function peg$f16() {    return { type: types.ANS }  }
  function peg$f17() {    return { type: types.GetKey }  }
  function peg$f18(head, tail) {    return util.buildList(head, tail);  }
  function peg$f19() {    return '-'  }
  function peg$f20(operator, argument) {    return { type: types.UnaryExpression, operator, argument }  }
  function peg$f21(operator, argument) {    return { type: types.UnaryExpression, operator, argument }  }
  function peg$f22(head, tail, end) {    return util.buildImplicitBinaryExpression(head, tail, end);  }
  function peg$f23(head, tail, end) {    return util.buildImplicitBinaryExpression(head, tail, end);  }
  function peg$f24(head, tail) {    return util.buildBinaryExpression(head, tail);  }
  function peg$f25(head, tail) {    return util.buildBinaryExpression(head, tail);  }
  function peg$f26() {    return '!='  }
  function peg$f27() {    return '>='  }
  function peg$f28() {    return '<='  }
  function peg$f29(head, tail) {    return util.buildBinaryExpression(head, tail);  }
  function peg$f30() {    return ' and '  }
  function peg$f31() {    return ' or '  }
  function peg$f32() {    return ' xor '  }
  function peg$f33(head, tail) {    return util.buildBinaryExpression(head, tail);  }
  function peg$f34() {    return true  }
  function peg$f35() {    return { type: types.EmptyStatement }  }
  function peg$f36(value) {    return { type: types.ValueStatement, value }  }
  function peg$f37(value, assignable) {    return { type: types.AssignmentStatement, value, assignable }  }
  function peg$f38(value, extra) {    return { type: types.IfStatement, value, extra }  }
  function peg$f39(extra) {    return { type: types.ThenStatement, extra }  }
  function peg$f40(extra) {    return { type: types.ElseStatement, extra }  }
  function peg$f41(variable, start, end, step, args, extra) {    return { type: types.ForLoop, variable, start, end, step, args, extra }  }
  function peg$f42(value, extra) {    return { type: types.WhileLoop, value, extra }  }
  function peg$f43(value, extra) {    return { type: types.RepeatLoop, value, extra }  }
  function peg$f44(extra) {    return { type: types.EndStatement, extra }  }
  function peg$f45() {    return { type: types.PauseStatement }  }
  function peg$f46(location) {    return { type: types.LabelStatement, location }  }
  function peg$f47(location) {    return { type: types.GotoStatement, location }  }
  function peg$f48(variable, end) {    return { type: types.IncrementSkip, variable, end }  }
  function peg$f49(variable, end) {    return { type: types.DecrementSkip, variable, end }  }
  function peg$f50(title, options) {    return util.buildMenuStatement(title, options);  }
  function peg$f51(name) {    return { type: types.ProgramStatement, name }  }
  function peg$f52() {    return { type: types.ReturnStatement }  }
  function peg$f53() {    return { type: types.StopStatement }  }
  function peg$f54(variable) {    return { type: types.DelVarStatement, variable }  }
  function peg$f55(equation, style) {    return { type: types.GraphStyleStatement, equation, style }  }
  function peg$f56(name) {    return { type: types.OpenLibStatement, name }  }
  function peg$f57(name) {    return { type: types.ExecLibStatement, name }  }
  function peg$f58(text, variable) {    return { type: types.Input, text, variable }  }
  function peg$f59(variable) {    return { type: types.Prompt, variable }  }
  function peg$f60(value) {    return { type: types.Display, value }  }
  function peg$f61() {    return { type: types.DispGraph }  }
  function peg$f62() {    return { type: types.DispTable }  }
  function peg$f63(row, column, value) {    return { type: types.Output, row, column, value }  }
  function peg$f64() {    return { type: types.ClrHome }  }
  function peg$f65() {    return { type: types.ClrTable }  }
  function peg$f66(variable, portflag) {    return { type: types.GetCalc, variable, portflag }  }
  function peg$f67(variable) {    return { type: types.Get, variable }  }
  function peg$f68(variable) {    return { type: types.Send, variable }  }
  let peg$currPos = options.peg$currPos | 0;
  let peg$savedPos = peg$currPos;
  const peg$posDetailsCache = [{ line: 1, column: 1 }];
  let peg$maxFailPos = peg$currPos;
  let peg$maxFailExpected = options.peg$maxFailExpected || [];
  let peg$silentFails = options.peg$silentFails | 0;

  let peg$result;

  if (options.startRule) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function offset() {
    return peg$savedPos;
  }

  function range() {
    return {
      source: peg$source,
      start: peg$savedPos,
      end: peg$currPos,
    };
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildSimpleError(message, location);
  }

  function peg$getUnicode(pos = peg$currPos) {
    const cp = input.codePointAt(pos);
    if (cp === undefined) {
      return "";
    }
    return String.fromCodePoint(cp);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text, ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
    return { type: "class", parts, inverted, ignoreCase, unicode };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description };
  }

  function peg$computePosDetails(pos) {
    let details = peg$posDetailsCache[pos];
    let p;

    if (details) {
      return details;
    } else {
      if (pos >= peg$posDetailsCache.length) {
        p = peg$posDetailsCache.length - 1;
      } else {
        p = pos;
        while (!peg$posDetailsCache[--p]) {}
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column,
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(startPos, endPos, offset) {
    const startPosDetails = peg$computePosDetails(startPos);
    const endPosDetails = peg$computePosDetails(endPos);

    const res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column,
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column,
      },
    };
    if (offset && peg$source && (typeof peg$source.offset === "function")) {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parseStart() {
    let s0;

    s0 = peg$parseStatement();

    return s0;
  }

  function peg$parsetok_() {
    let s0;

    if (input.substr(peg$currPos, 2) === peg$c0) {
      s0 = peg$c0;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e0); }
    }

    return s0;
  }

  function peg$parse_tok() {
    let s0;

    if (input.charCodeAt(peg$currPos) === 125) {
      s0 = peg$c1;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e1); }
    }

    return s0;
  }

  function peg$parseSourceCharacter() {
    let s0;

    if (input.length > peg$currPos) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e2); }
    }

    return s0;
  }

  function peg$parseAlpha() {
    let s0;

    s0 = input.charAt(peg$currPos);
    if (peg$r0.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e3); }
    }

    return s0;
  }

  function peg$parseAlphaNum() {
    let s0;

    s0 = input.charAt(peg$currPos);
    if (peg$r1.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e4); }
    }

    return s0;
  }

  function peg$parseDigit() {
    let s0;

    s0 = input.charAt(peg$currPos);
    if (peg$r2.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e5); }
    }

    return s0;
  }

  function peg$parseExtraCharacters() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseSourceCharacter();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseSourceCharacter();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f0();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseOptionalEndParen() {
    let s0;

    if (input.charCodeAt(peg$currPos) === 41) {
      s0 = peg$c2;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e6); }
    }
    if (s0 === peg$FAILED) {
      s0 = null;
    }

    return s0;
  }

  function peg$parseLocation() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$parseAlphaNum();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseAlphaNum();
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f1();
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseProgramName() {
    let s0, s1, s2, s3, s4, s5, s6, s7, s8;

    s0 = peg$currPos;
    s1 = peg$parseAlpha();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseAlphaNum();
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      s3 = peg$parseAlphaNum();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parseAlphaNum();
      if (s4 === peg$FAILED) {
        s4 = null;
      }
      s5 = peg$parseAlphaNum();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parseAlphaNum();
      if (s6 === peg$FAILED) {
        s6 = null;
      }
      s7 = peg$parseAlphaNum();
      if (s7 === peg$FAILED) {
        s7 = null;
      }
      s8 = peg$parseAlphaNum();
      if (s8 === peg$FAILED) {
        s8 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f2();
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseNumericVariableIdentifier() {
    let s0, s1, s2, s3;

    s0 = peg$parseAlpha();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsetok_();
      if (s1 !== peg$FAILED) {
        if (input.substr(peg$currPos, 5) === peg$c3) {
          s2 = peg$c3;
          peg$currPos += 5;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e7); }
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_tok();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f3();
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseStringVariableIdentifier() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 3) === peg$c4) {
        s2 = peg$c4;
        peg$currPos += 3;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseDigit();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_tok();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f4();
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseListVariableIdentifier() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 76) {
        s2 = peg$c5;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e9); }
      }
      if (s2 !== peg$FAILED) {
        s3 = input.charAt(peg$currPos);
        if (peg$r3.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e10); }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_tok();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f5(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseCustomListVariableIdentifier() {
    let s0, s1, s2, s3, s4, s5, s6, s7, s8;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c6) {
        s2 = peg$c6;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e11); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseAlpha();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseAlphaNum();
            if (s5 === peg$FAILED) {
              s5 = null;
            }
            s6 = peg$parseAlphaNum();
            if (s6 === peg$FAILED) {
              s6 = null;
            }
            s7 = peg$parseAlphaNum();
            if (s7 === peg$FAILED) {
              s7 = null;
            }
            s8 = peg$parseAlphaNum();
            if (s8 === peg$FAILED) {
              s8 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f6(s2);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseNumericVariable() {
    let s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseNumericVariableIdentifier();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f7(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseStringVariable() {
    let s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseStringVariableIdentifier();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f8(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseListVariable() {
    let s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseListVariableIdentifier();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f9(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseCustomListVariableIdentifier();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f10(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseVariable() {
    let s0;

    s0 = peg$parseStringVariable();
    if (s0 === peg$FAILED) {
      s0 = peg$parseNumericVariable();
      if (s0 === peg$FAILED) {
        s0 = peg$parseListVariable();
      }
    }

    return s0;
  }

  function peg$parseListIndex() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parseListVariable();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c7;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e12); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseValueExpression();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f11(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseAssignable() {
    let s0;

    s0 = peg$parseListIndex();
    if (s0 === peg$FAILED) {
      s0 = peg$parseVariable();
    }

    return s0;
  }

  function peg$parseInteger() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseDigit();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseDigit();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parseSignedInteger() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = input.charAt(peg$currPos);
    if (peg$r4.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e13); }
    }
    if (s2 === peg$FAILED) {
      s2 = null;
    }
    s3 = peg$parseInteger();
    if (s3 !== peg$FAILED) {
      s2 = [s2, s3];
      s1 = s2;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parseExponentIndicator() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 69) {
        s2 = peg$c8;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e14); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s1 = [s1, s2, s3];
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseExponentPart() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseExponentIndicator();
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parseSignedInteger();
      if (s3 !== peg$FAILED) {
        s2 = input.substring(s2, peg$currPos);
      } else {
        s2 = s3;
      }
      if (s2 !== peg$FAILED) {
        s0 = s2;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseNumericLiteral() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parseInteger();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 46) {
        s2 = peg$c9;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e15); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseInteger();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        s4 = peg$parseExponentPart();
        if (s4 === peg$FAILED) {
          s4 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f12(s1, s3, s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 46) {
        s1 = peg$c9;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e15); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parseInteger();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseExponentPart();
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f13(s2, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseInteger();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseExponentPart();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f14(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parseCharacter() {
    let s0;

    s0 = input.charAt(peg$currPos);
    if (peg$r5.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e16); }
    }

    return s0;
  }

  function peg$parseCharacterString() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseCharacter();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parseCharacter();
    }
    s0 = input.substring(s0, peg$currPos);

    return s0;
  }

  function peg$parseStringLiteral() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c10;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e17); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseCharacterString();
      if (input.charCodeAt(peg$currPos) === 34) {
        s3 = peg$c10;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e17); }
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f15(s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseAnswer() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 3) === peg$c11) {
        s2 = peg$c11;
        peg$currPos += 3;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e18); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f16();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseGetKey() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s2 = peg$c12;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f17();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseToken() {
    let s0;

    s0 = peg$parseAnswer();
    if (s0 === peg$FAILED) {
      s0 = peg$parseGetKey();
    }

    return s0;
  }

  function peg$parseTokenLiteral() {
    let s0;

    s0 = peg$parseToken();
    if (s0 === peg$FAILED) {
      s0 = peg$parseAssignable();
      if (s0 === peg$FAILED) {
        s0 = peg$parseStringLiteral();
      }
    }

    return s0;
  }

  function peg$parseListExpression() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c13;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e20); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseValueExpression();
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parseArgumentExpression();
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parseArgumentExpression();
        }
        if (input.charCodeAt(peg$currPos) === 125) {
          s4 = peg$c1;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e1); }
        }
        if (s4 === peg$FAILED) {
          s4 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f18(s2, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTokenExpression() {
    let s0, s1, s2, s3;

    s0 = peg$parseTokenLiteral();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e12); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parseValueExpression();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 41) {
            s3 = peg$c2;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e6); }
          }
          if (s3 !== peg$FAILED) {
            s0 = s2;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parseListExpression();
      }
    }

    return s0;
  }

  function peg$parseUnaryOperator() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 45) {
        s2 = peg$c14;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e21); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f19();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTokenUnaryExpression() {
    let s0, s1, s2;

    s0 = peg$parseTokenExpression();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseUnaryOperator();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseTokenUnaryExpression();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f20(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseUnaryExpression() {
    let s0, s1, s2;

    s0 = peg$parseTokenUnaryExpression();
    if (s0 === peg$FAILED) {
      s0 = peg$parseNumericLiteral();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseUnaryOperator();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseUnaryExpression();
          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f21(s1, s2);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parseImplicitMultiplicativeExpression() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseTokenUnaryExpression();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseUnaryExpression();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseTokenUnaryExpression();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseUnaryExpression();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseTokenUnaryExpression();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      s3 = peg$parseUnaryExpression();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f22(s1, s2, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseUnaryExpression();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parseTokenUnaryExpression();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseUnaryExpression();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parseTokenUnaryExpression();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseUnaryExpression();
            if (s5 !== peg$FAILED) {
              s4 = [s4, s5];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        s3 = peg$parseTokenUnaryExpression();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f23(s1, s2, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parseUnaryExpression();
      }
    }

    return s0;
  }

  function peg$parseMultiplicativeOperator() {
    let s0;

    s0 = input.charAt(peg$currPos);
    if (peg$r6.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e22); }
    }

    return s0;
  }

  function peg$parseMultiplicativeExpression() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseImplicitMultiplicativeExpression();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseMultiplicativeOperator();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseImplicitMultiplicativeExpression();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseMultiplicativeOperator();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseImplicitMultiplicativeExpression();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f24(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseAdditiveOperator() {
    let s0;

    s0 = input.charAt(peg$currPos);
    if (peg$r4.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e13); }
    }

    return s0;
  }

  function peg$parseAdditiveExpression() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseMultiplicativeExpression();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseAdditiveOperator();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseMultiplicativeExpression();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseAdditiveOperator();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseMultiplicativeExpression();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f25(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseTestOperator() {
    let s0, s1, s2, s3;

    if (input.charCodeAt(peg$currPos) === 61) {
      s0 = peg$c15;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e23); }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsetok_();
      if (s1 !== peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c16) {
          s2 = peg$c16;
          peg$currPos += 2;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e24); }
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_tok();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f26();
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsetok_();
        if (s1 !== peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c17) {
            s2 = peg$c17;
            peg$currPos += 2;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e25); }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parse_tok();
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f27();
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 62) {
            s0 = peg$c18;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e26); }
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsetok_();
            if (s1 !== peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c19) {
                s2 = peg$c19;
                peg$currPos += 2;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e27); }
              }
              if (s2 !== peg$FAILED) {
                s3 = peg$parse_tok();
                if (s3 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f28();
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 60) {
                s0 = peg$c20;
                peg$currPos++;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e28); }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseTestExpression() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseAdditiveExpression();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseTestOperator();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseAdditiveExpression();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseTestOperator();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseAdditiveExpression();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f29(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLogicalOperator() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c21) {
        s2 = peg$c21;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f30();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsetok_();
      if (s1 !== peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c22) {
          s2 = peg$c22;
          peg$currPos += 4;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e30); }
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_tok();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f31();
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsetok_();
        if (s1 !== peg$FAILED) {
          if (input.substr(peg$currPos, 5) === peg$c23) {
            s2 = peg$c23;
            peg$currPos += 5;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e31); }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parse_tok();
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f32();
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    return s0;
  }

  function peg$parseValueExpression() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseTestExpression();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parseLogicalOperator();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseTestExpression();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parseLogicalOperator();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseTestExpression();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f33(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseArgumentExpression() {
    let s0, s1, s2;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 44) {
      s1 = peg$c24;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e32); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseValueExpression();
      if (s2 !== peg$FAILED) {
        s0 = s2;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePrefixArgumentExpression() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$parseValueExpression();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c24;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e32); }
      }
      if (s2 !== peg$FAILED) {
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseExtraArguments() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseArgumentExpression();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseArgumentExpression();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f34();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseEmptyStatement() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseSourceCharacter();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f35();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseValueStatement() {
    let s0, s1;

    s0 = peg$currPos;
    s1 = peg$parseValueExpression();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f36(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseAssignment() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseValueExpression();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsetok_();
      if (s2 !== peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c25) {
          s3 = peg$c25;
          peg$currPos += 2;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e33); }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_tok();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseAssignable();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f37(s1, s5);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIfStatement() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 3) === peg$c26) {
        s2 = peg$c26;
        peg$currPos += 3;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e34); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseValueExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseExtraCharacters();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f38(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseThen() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c27) {
        s2 = peg$c27;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e35); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseExtraCharacters();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f39(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseElse() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c28) {
        s2 = peg$c28;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e36); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseExtraCharacters();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f40(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseFor() {
    let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c29) {
        s2 = peg$c29;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e37); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseArgumentExpression();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          s6 = peg$parseArgumentExpression();
          if (s6 === peg$FAILED) {
            s6 = null;
          }
          s7 = peg$parseArgumentExpression();
          if (s7 === peg$FAILED) {
            s7 = null;
          }
          s8 = peg$parseExtraArguments();
          if (s8 === peg$FAILED) {
            s8 = null;
          }
          s9 = peg$parseOptionalEndParen();
          s10 = peg$parseExtraCharacters();
          if (s10 === peg$FAILED) {
            s10 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f41(s4, s5, s6, s7, s8, s10);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseWhile() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c30) {
        s2 = peg$c30;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e38); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseValueExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseExtraCharacters();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f42(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseRepeat() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s2 = peg$c31;
        peg$currPos += 7;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e39); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseValueExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseExtraCharacters();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f43(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseEnd() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 3) === peg$c32) {
        s2 = peg$c32;
        peg$currPos += 3;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e40); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseExtraCharacters();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f44(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePause() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c33) {
        s2 = peg$c33;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e41); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f45();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLabel() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c34) {
        s2 = peg$c34;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e42); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseLocation();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f46(s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseGoto() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c35) {
        s2 = peg$c35;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e43); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseLocation();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f47(s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIncrementSkip() {
    let s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c36) {
        s2 = peg$c36;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e44); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseArgumentExpression();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          s6 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f48(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDecrementSkip() {
    let s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c37) {
        s2 = peg$c37;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e45); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseArgumentExpression();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          s6 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f49(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseMenu() {
    let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c38) {
        s2 = peg$c38;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e46); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseValueExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = [];
          s6 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s7 = peg$c24;
            peg$currPos++;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e32); }
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parseStringLiteral();
            if (s8 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s9 = peg$c24;
                peg$currPos++;
              } else {
                s9 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e32); }
              }
              if (s9 !== peg$FAILED) {
                s10 = peg$parseLocation();
                if (s10 !== peg$FAILED) {
                  s7 = [s7, s8, s9, s10];
                  s6 = s7;
                } else {
                  peg$currPos = s6;
                  s6 = peg$FAILED;
                }
              } else {
                peg$currPos = s6;
                s6 = peg$FAILED;
              }
            } else {
              peg$currPos = s6;
              s6 = peg$FAILED;
            }
          } else {
            peg$currPos = s6;
            s6 = peg$FAILED;
          }
          while (s6 !== peg$FAILED) {
            s5.push(s6);
            s6 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 44) {
              s7 = peg$c24;
              peg$currPos++;
            } else {
              s7 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e32); }
            }
            if (s7 !== peg$FAILED) {
              s8 = peg$parseStringLiteral();
              if (s8 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 44) {
                  s9 = peg$c24;
                  peg$currPos++;
                } else {
                  s9 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e32); }
                }
                if (s9 !== peg$FAILED) {
                  s10 = peg$parseLocation();
                  if (s10 !== peg$FAILED) {
                    s7 = [s7, s8, s9, s10];
                    s6 = s7;
                  } else {
                    peg$currPos = s6;
                    s6 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s6;
                  s6 = peg$FAILED;
                }
              } else {
                peg$currPos = s6;
                s6 = peg$FAILED;
              }
            } else {
              peg$currPos = s6;
              s6 = peg$FAILED;
            }
          }
          s6 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f50(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseProgram() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c39) {
        s2 = peg$c39;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e47); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseProgramName();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f51(s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseReturn() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c40) {
        s2 = peg$c40;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e48); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f52();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseStop() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c41) {
        s2 = peg$c41;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e49); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f53();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDelVar() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 7) === peg$c42) {
        s2 = peg$c42;
        peg$currPos += 7;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e50); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f54(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseGraphStyle() {
    let s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 11) === peg$c43) {
        s2 = peg$c43;
        peg$currPos += 11;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e51); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseValueExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseArgumentExpression();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          s6 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f55(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseOpenLib() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 8) === peg$c44) {
        s2 = peg$c44;
        peg$currPos += 8;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e52); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseProgramName();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseOptionalEndParen();
            peg$savedPos = s0;
            s0 = peg$f56(s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseExecLib() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 8) === peg$c45) {
        s2 = peg$c45;
        peg$currPos += 8;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e53); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseProgramName();
          if (s4 !== peg$FAILED) {
            s5 = peg$parseOptionalEndParen();
            peg$savedPos = s0;
            s0 = peg$f57(s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseCtlStatement() {
    let s0;

    s0 = peg$parseIfStatement();
    if (s0 === peg$FAILED) {
      s0 = peg$parseThen();
      if (s0 === peg$FAILED) {
        s0 = peg$parseElse();
        if (s0 === peg$FAILED) {
          s0 = peg$parseFor();
          if (s0 === peg$FAILED) {
            s0 = peg$parseWhile();
            if (s0 === peg$FAILED) {
              s0 = peg$parseRepeat();
              if (s0 === peg$FAILED) {
                s0 = peg$parseEnd();
                if (s0 === peg$FAILED) {
                  s0 = peg$parsePause();
                  if (s0 === peg$FAILED) {
                    s0 = peg$parseLabel();
                    if (s0 === peg$FAILED) {
                      s0 = peg$parseGoto();
                      if (s0 === peg$FAILED) {
                        s0 = peg$parseIncrementSkip();
                        if (s0 === peg$FAILED) {
                          s0 = peg$parseDecrementSkip();
                          if (s0 === peg$FAILED) {
                            s0 = peg$parseMenu();
                            if (s0 === peg$FAILED) {
                              s0 = peg$parseProgram();
                              if (s0 === peg$FAILED) {
                                s0 = peg$parseReturn();
                                if (s0 === peg$FAILED) {
                                  s0 = peg$parseStop();
                                  if (s0 === peg$FAILED) {
                                    s0 = peg$parseDelVar();
                                    if (s0 === peg$FAILED) {
                                      s0 = peg$parseGraphStyle();
                                      if (s0 === peg$FAILED) {
                                        s0 = peg$parseOpenLib();
                                        if (s0 === peg$FAILED) {
                                          s0 = peg$parseExecLib();
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseInput() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c46) {
        s2 = peg$c46;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e54); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parsePrefixArgumentExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseVariable();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f58(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsePrompt() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 7) === peg$c47) {
        s2 = peg$c47;
        peg$currPos += 7;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e55); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f59(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDisplay() {
    let s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c48) {
        s2 = peg$c48;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e56); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseValueExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f60(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDispGraph() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 9) === peg$c49) {
        s2 = peg$c49;
        peg$currPos += 9;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e57); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f61();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDispTable() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 9) === peg$c50) {
        s2 = peg$c50;
        peg$currPos += 9;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e58); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f62();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseOutput() {
    let s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 7) === peg$c51) {
        s2 = peg$c51;
        peg$currPos += 7;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e59); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseValueExpression();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseArgumentExpression();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          s6 = peg$parseArgumentExpression();
          if (s6 === peg$FAILED) {
            s6 = null;
          }
          s7 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f63(s4, s5, s6);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseClrHome() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 7) === peg$c52) {
        s2 = peg$c52;
        peg$currPos += 7;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e60); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f64();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseClrTable() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 8) === peg$c53) {
        s2 = peg$c53;
        peg$currPos += 8;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e61); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f65();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseGetCalc() {
    let s0, s1, s2, s3, s4, s5, s6;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 8) === peg$c54) {
        s2 = peg$c54;
        peg$currPos += 8;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e62); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseArgumentExpression();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          s6 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f66(s4, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseGet() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 4) === peg$c55) {
        s2 = peg$c55;
        peg$currPos += 4;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e63); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f67(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSend() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parsetok_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 5) === peg$c56) {
        s2 = peg$c56;
        peg$currPos += 5;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e64); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_tok();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseVariable();
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          s5 = peg$parseOptionalEndParen();
          peg$savedPos = s0;
          s0 = peg$f68(s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIoStatement() {
    let s0;

    s0 = peg$parseInput();
    if (s0 === peg$FAILED) {
      s0 = peg$parsePrompt();
      if (s0 === peg$FAILED) {
        s0 = peg$parseDisplay();
        if (s0 === peg$FAILED) {
          s0 = peg$parseDispGraph();
          if (s0 === peg$FAILED) {
            s0 = peg$parseDispTable();
            if (s0 === peg$FAILED) {
              s0 = peg$parseOutput();
              if (s0 === peg$FAILED) {
                s0 = peg$parseClrHome();
                if (s0 === peg$FAILED) {
                  s0 = peg$parseClrTable();
                  if (s0 === peg$FAILED) {
                    s0 = peg$parseGetCalc();
                    if (s0 === peg$FAILED) {
                      s0 = peg$parseGet();
                      if (s0 === peg$FAILED) {
                        s0 = peg$parseSend();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseStatement() {
    let s0;

    s0 = peg$parseEmptyStatement();
    if (s0 === peg$FAILED) {
      s0 = peg$parseAssignment();
      if (s0 === peg$FAILED) {
        s0 = peg$parseCtlStatement();
        if (s0 === peg$FAILED) {
          s0 = peg$parseIoStatement();
          if (s0 === peg$FAILED) {
            s0 = peg$parseValueStatement();
          }
        }
      }
    }

    return s0;
  }


  const types = require ('../common/types');
  const util = require ('./pegutil');

  peg$result = peg$startRuleFunction();

  const peg$success = (peg$result !== peg$FAILED && peg$currPos === input.length);
  function peg$throw() {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
  if (options.peg$library) {
    return /** @type {any} */ ({
      peg$result,
      peg$currPos,
      peg$FAILED,
      peg$maxFailExpected,
      peg$maxFailPos,
      peg$success,
      peg$throw: peg$success ? undefined : peg$throw,
    });
  }
  if (peg$success) {
    return peg$result;
  } else {
    peg$throw();
  }
}

module.exports = {
  StartRules: ["Start"],
  SyntaxError: peg$SyntaxError,
  parse: peg$parse,
};
